import { jwtDecode } from 'jwt-decode';

const actions = {
	setUserInformationOfToken(token: string) {
		const tokenData: any = jwtDecode(token);
		this.userInformation.name = tokenData.Name;
		this.userInformation.phoneNumber = tokenData.PhoneNumber;
		this.userInformation.userId = tokenData.Id;
		this.userInformation.role = tokenData?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
		this.userInformation.loggedIn = true;
	},
	logout() {
		this.userInformation.name = '';
		this.userInformation.phoneNumber = '';
		this.userInformation.loggedIn = false;
		this.userInformation.role = 'AllUser';
	},
	setBusinessInfo(businessInfo: object) {
		this.businessInfo = { ...businessInfo };
	},
	setArtistInfo(artistInfo: object) {
		this.artistInfo = { ...artistInfo };
	},
	setServiceInfo(serviceInfo: object) {
		this.serviceInfo = [...serviceInfo];
	},
	setTimeInfo(timeInfo: object) {
		this.timeInfo = { ...timeInfo };
	},

	resetStore() {
		this.userInformation = {
			name: '',
			phoneNumber: '',
			userId: '',
			role: 'AllUser',
			loggedIn: false,
			city: {
				id: 4,
				faName: 'مشهد',
				alternatives: ['mashhad'],
				key: 'mashhad',
			},
		};
		this.businessInfo = {};
		this.artistInfo = {};
		this.serviceInfo = [];
		this.timeInfo = {};
	},
};

export default actions;
